import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
